// initial state
import ApplicationService from '../../api/application';
import Vue from 'vue';
const state = {
  app_tags: [],
  globalDrawerConfig: {
    visible: false,
    width: 500,
    component: '',
    title: '',
    icon: '',
    props: {},
  },
  foreignLinkWarningConfig: {
    visible: false,
    flaggedUrl: '',
  },
  appConfig: {},
  featureFlags: {},
  activeRoute: null,
  activeDataSource: 'publication',
  activeView: {
    publication: 'documents',
    patent: 'documents',
    funding: 'dollars',
  },
  dataSourceData: {
    openalex: {
      totalCount: null,
      repository: [],
      journal: [],
      conference: [],
    },
    patstat: {
      totalCount: null,
      authority: [],
    },
    federalfunding: {
      totalCount: null,
      agency: [],
    },
  },
  dataSourcePagination: {
    repository: {
      page: 1,
      rowsPerPage: 10,
      rowsNumber: null,
      sortBy: 'works_count',
      descending: true,
    },
    journal: {
      page: 1,
      rowsPerPage: 10,
      rowsNumber: null,
      sortBy: 'works_count',
      descending: true,
    },
    conference: {
      page: 1,
      rowsPerPage: 10,
      rowsNumber: null,
      sortBy: 'works_count',
      descending: true,
    },
    authority: {
      page: 1,
      rowsPerPage: 10,
      rowsNumber: null,
      sortBy: 'patent_count',
      descending: true,
    },
    agency: {
      page: 1,
      rowsPerPage: 10,
      rowsNumber: null,
      sortBy: 'grant_count',
      descending: true,
    },
    funder: {
      page: 1,
      rowsPerPage: 10,
      rowsNumber: null,
      sortBy: 'deal_count',
      descending: true,
    },
    recipient: {
      page: 1,
      rowsPerPage: 10,
      rowsNumber: null,
      sortBy: 'deal_count',
      descending: true,
    },
  },
  dataSourceSearch: {
    repository: '',
    journal: '',
    conference: '',
    authority: '',
    agency: '',
    funder: '',
    recipient: '',
  },
  dataSourceLoading: false,
  tutorialVideos: [],
  tutorialVideosLoading: false,
};

const getters = {
  applicationTags: (state) => {
    return state.app_tags;
  },
  // Return state of globalDrawer
  globalDrawerConfig: (state) => {
    return state.globalDrawerConfig;
  },
  appConfig: (state) => {
    return state.appConfig;
  },
  featureFlags: (state) => {
    return state.featureFlags;
  },
  foreignLinkWarningConfig: (state) => {
    return state.foreignLinkWarningConfig;
  },
  activeRoute: (state) => {
    return state.activeRoute;
  },
  activeDataSource: (state) => {
    return state.activeDataSource;
  },
  activeView: (state) => {
    return state.activeView;
  },
  dataSourceData: (state) => {
    return state.dataSourceData;
  },
  dataSourcePagination: (state) => {
    return state.dataSourcePagination;
  },
  dataSourceSearch: (state) => {
    return state.dataSourceSearch;
  },
  dataSourceLoading: (state) => {
    return state.dataSourceLoading;
  },
  tutorialVideos: (state) => {
    return state.tutorialVideos;
  },
  tutorialVideosLoading: (state) => {
    return state.tutorialVideosLoading;
  },
};

const actions = {
  async getApplicationTags({ commit }) {
    let appService = new ApplicationService();
    const response = await appService.loadAppTags();
    if (response) {
      commit('setApplicatonTags', response);
    }
  },
  setGlobalDrawerConfig({ commit }, config) {
    commit('setGlobalDrawerConfig', config);
  },
  setForeignLinkWarningConfig({ commit }, config) {
    commit('setForeignLinkWarningConfig', config);
  },
  checkForeignLink({ commit }, url) {
    // Check incoming URL to see if it points to a Russian, Chinese, or Iranian domain
    try {
      // List of foreign domains to check for
      const flaggedDomains = [
        '.ir', // Iran
        '.ru', // Russia
        '.su', // Former Soviet Union (still active)
        '.cn', // Mainland China
        '.hk', // Hong Kong
        '.mo', // Macau
        '.unicom', // China Unicom
        '.yamaxun', // Amazon China
        '.中国', // Primary Chinese alternative to .cn
      ];
      const processedUrl = new URL(url);
      // Store hostname of processed URL
      const hostname = processedUrl.hostname.toLowerCase();
      let urlIsSafe = true;

      // Check if hostname ends with any of the foreign domains
      for (const domain of flaggedDomains) {
        if (hostname.endsWith(domain)) {
          // This is a foreign domain we want to flag -- Set urlIsSafe var
          urlIsSafe = false;
          // Call mutation to update foreign link warning config to show warning dialog to user and set URL to state
          commit('setForeignLinkWarningConfig', {
            visible: true,
            flaggedUrl: url,
          });
        }
      }
      if (urlIsSafe) {
        // Url is safe to open without warning
        window.open(url, '_blank');
      }
    } catch (e) {
      // If URL is invalid return false
    }
  },
  setAppConfig({ commit }, config) {
    if (config) {
      commit('setAppConfig', config);
    }
  },
  setActiveRoute({ commit }, routeName) {
    commit('setActiveRoute', routeName);
  },
  setActiveView({ commit }, payload) {
    commit('setActiveView', payload);
  },
  changeActiveDataSource({ commit }, payload) {
    commit('setActiveDataSource', payload);
  },
  async getDataSourceData({ commit, dispatch }, payload) {
    // Set loading to true while we fetch data
    commit('setDataSourceLoading', true);
    // Dispatch appropriate action for payload source
    switch (payload.source) {
      case 'openalex':
        return await dispatch('getOpenAlexData', payload);
      case 'patstat':
        break;
      case 'federalfunding':
        break;
      default:
        break;
    }
  },
  async getOpenAlexData({ commit, state }, payload) {
    const { type, pagination, source } = payload;
    const _payload = {
      type,
      size: pagination.rowsPerPage,
      page: pagination.page,
      sort: {
        field: pagination.sortBy,
        direction: pagination.descending ? 'DESC' : 'ASC',
      },
      search: state.dataSourceSearch[type],
    };
    let appService = new ApplicationService();
    const response = await appService.getOpenAlexData(_payload);

    commit('setDataSourceLoading', false);

    if (response && response.success) {
      commit('setDataSourceData', { source, type, data: response.data });
      commit('setDataSourcePagination', {
        type,
        pagination: { ...pagination, rowsNumber: response.totalRows },
      });
      return true;
    } else {
      return false;
    }
  },
  async getDataSourceTotals({ commit }, payload) {
    let appService = new ApplicationService();
    const response = await appService.getDataSourceTotals();
    if (response && response.success !== false) {
      commit('setDataSourceTotals', response);
    }
  },
  setDataSourceSearch({ commit }, payload) {
    const { type, search } = payload;
    commit('setDataSourceSearch', { type, search });
  },
  // Get list of tutorial videos from DB
  async getTutorialVideos({ commit }, payload) {
    // Set loading stat to true while we fetch data
    commit('setTutorialVideosLoading', true);
    let appService = new ApplicationService();
    const response = await appService.getTutorialVideos();
    if (response && response.success !== false) {
      commit('setTutorialVideos', response.data);
      // Set loading stat to false now that data has been fetched
      commit('setTutorialVideosLoading', false);
    }
  },
};

// mutations
const mutations = {
  setApplicatonTags(state, payload) {
    state.app_tags = payload;
  },
  setGlobalDrawerConfig(state, payload) {
    // No payload = reset to default state, i.e. close the drawer
    if (!payload) {
      state.globalDrawerConfig = {
        visible: false,
        width: 500,
        component: '',
        title: '',
        icon: '',
        props: {},
      };
    } else {
      // Spread prev state so we can just pass updated properties instead of entire object
      state.globalDrawerConfig = { ...state.globalDrawerConfig, ...payload };
    }
  },
  setForeignLinkWarningConfig(state, payload) {
    // No payload = reset to default state, i.e. close dialog
    if (!payload) {
      state.foreignLinkWarningConfig = {
        visible: false,
        url: '',
      };
    } else {
      // Spread prev state so we can just pass updated properties instead of entire object
      state.foreignLinkWarningConfig = {
        ...state.foreignLinkWarningConfig,
        ...payload,
      };
    }
  },
  setAppConfig(state, payload) {
    state.appConfig = payload;
  },
  setActiveRoute(state, payload) {
    state.activeRoute = payload;
  },
  setActiveDataSource(state, payload) {
    state.activeDataSource = payload;
  },
  setActiveView(state, payload) {
    const { tab, activeView } = payload;
    // We have a tab and active view, update the active view for the tab in state
    if (activeView && tab) {
      Vue.set(state.activeView, tab, activeView);
    } else {
      // We do not have a tab or active view, e.g. when loading the dashboard, reset all active views to default
      state.activeView = {
        publication: 'documents',
        patent: 'documents',
        funding: 'dollars',
      };
    }
  },
  setDataSourceData(state, payload) {
    // Set data for payload source and type
    const { source, type, data } = payload;
    Vue.set(state.dataSourceData[source], type, data);
  },
  setDataSourcePagination(state, payload) {
    // Set pagination for payload type
    const { type, pagination } = payload;
    Vue.set(state.dataSourcePagination, type, pagination);
  },
  setDataSourceSearch(state, payload) {
    // Set search for payload type
    const { type, search } = payload;
    Vue.set(state.dataSourceSearch, type, search);
  },
  setDataSourceLoading(state, payload) {
    state.dataSourceLoading = payload;
  },
  setDataSourceTotals(state, payload) {
    for (const source in payload) {
      Vue.set(state.dataSourceData[source], 'totalCount', payload[source]);
    }
  },
  setTutorialVideos(state, payload) {
    state.tutorialVideos = payload;
  },
  setTutorialVideosLoading(state, payload) {
    state.tutorialVideosLoading = payload;
  },
  setFeatureFlags(state, payload) {
    state.featureFlags = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
